import React from "react";
import './aboutglimpse.css';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from "react-router-dom";

const AboutGlimpse = () => {
  return (
    <section className="about-glimpse py-5">
      <Container>
        <Row className="justify-content-center text-center">
          <Col lg={8}>
            <h2 className="mb-3">About Us</h2>
            <h3 className="mb-4">Reach More People with Us</h3>
            <p className="lead">
              Iklim Digitals empowers brands to grow their presence in the Ethiopian market through impactful and strategic advertising solutions.
            </p>
            <Link to="/aboutus">
  <Button variant="outline-warning" className="read-more-btn">
    Read More
  </Button>
</Link>

          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutGlimpse;
